import api from './api';

export const shiftsApi = {
  getMonthShifts: (driverId, year, month) => 
    api.get(`/api/shifts/driver/${driverId}/month?year=${year}&month=${month}`),
  updateShift: (shiftId, data) => 
    api.patch(`/api/shifts/shift/${shiftId}`, data),
};
